// Generated by gen-procedures-payload.mjs from content/procedures/*.yaml.
export const PROCEDURE_CONCERNS = ["lines","laxity","volume","fat","spots","redness","acne","quality","veins"] as const

export const PROCEDURES_INDEX = [
  {
    "href": "/procedures/belkyra",
    "title": "Belkyra",
    "targets": "Fullness under the chin",
    "method": "injection",
    "description": "Deoxycholic acid",
    "concerns": [
      "fat"
    ],
    "aliases": "Belkyra Deoxycholic acid · AbbVie"
  },
  {
    "href": "/procedures/biostimulators",
    "title": "Biostimulators",
    "targets": "Cheek wrinkles, nasolabial folds and volume loss in the hands",
    "method": "injection",
    "description": "Sculptra · Radiesse",
    "concerns": [
      "lines",
      "volume"
    ],
    "aliases": "Sculptra and Radiesse Poly-L-lactic acid (Sculptra) and calcium hydroxylapatite (Radiesse)"
  },
  {
    "href": "/procedures/botulinum-toxin",
    "title": "Botulinum toxin",
    "targets": "Frown lines, forehead lines and crow’s feet",
    "method": "injection",
    "description": "Botox, Dysport & more",
    "concerns": [
      "lines"
    ],
    "aliases": "Botulinum toxin Botulinum toxin type A · Botox Cosmetic, Dysport Aesthetic, Xeomin Cosmetic, Nuceiva and Letybo"
  },
  {
    "href": "/procedures/chemical-peels",
    "title": "Chemical peels",
    "targets": "Acne and sun spots, as published trials measured them",
    "method": "peel",
    "description": "Alpha-hydroxy, salicylic and trichloroacetic acids",
    "concerns": [
      "spots",
      "acne"
    ],
    "aliases": "Chemical peels Alpha-hydroxy, salicylic and trichloroacetic acids, phenol"
  },
  {
    "href": "/procedures/cryolipolysis",
    "title": "Cryolipolysis",
    "targets": "Fat under the chin and on the abdomen, flanks, arms and thighs",
    "method": "device",
    "description": "CoolSculpting",
    "concerns": [
      "fat"
    ],
    "aliases": "Cryolipolysis Cold-assisted lipolysis · CoolSculpting Elite, AbbVie"
  },
  {
    "href": "/procedures/dermal-fillers",
    "title": "Dermal fillers",
    "targets": "Under-eye hollows, cheeks, nasolabial folds, lips and jawline",
    "method": "injection",
    "description": "Hyaluronic acid fillers",
    "concerns": [
      "lines",
      "volume"
    ],
    "aliases": "Dermal fillers Hyaluronic acid · Juvéderm Volbella, Voluma, Volift and Volux; Restylane Kysse and Lyft"
  },
  {
    "href": "/procedures/hifu",
    "title": "HIFU",
    "targets": "Loose skin on the brow, under the chin and on the neck; lines on the chest",
    "method": "device",
    "description": "Ultherapy · focused ultrasound",
    "concerns": [
      "laxity",
      "lines"
    ],
    "aliases": "HIFU Micro-focused ultrasound · Ultherapy, Ulthera (Merz)"
  },
  {
    "href": "/procedures/ipl",
    "title": "IPL",
    "targets": "Rosacea redness and melasma",
    "method": "device",
    "description": "Intense pulsed light",
    "concerns": [
      "spots",
      "redness"
    ],
    "aliases": "IPL Intense pulsed light · Lumenis M22 and Stellar M22"
  },
  {
    "href": "/procedures/morpheus8",
    "title": "Morpheus8",
    "targets": "Loose skin on the face and neck, as published studies measured it",
    "method": "device",
    "description": "Radiofrequency microneedling",
    "concerns": [
      "laxity"
    ],
    "aliases": "Morpheus8 Radiofrequency microneedling · InMode"
  },
  {
    "href": "/procedures/sclerotherapy",
    "title": "Sclerotherapy",
    "targets": "Varicose veins of the legs",
    "method": "injection",
    "description": "Sodium tetradecyl sulfate · Tromboject",
    "concerns": [
      "veins"
    ],
    "aliases": "Sclerotherapy Sodium tetradecyl sulfate · Tromboject, Omega Laboratories"
  },
  {
    "href": "/procedures/skin-boosters",
    "title": "Skin boosters",
    "targets": "The overall look of skin on the face and hands",
    "method": "injection",
    "description": "Restylane Skinboosters · Teosyal Redensity 1",
    "concerns": [
      "quality"
    ],
    "aliases": "Skin boosters Hyaluronic acid · Restylane Skinboosters Vital and Teosyal PureSense Redensity 1"
  },
  {
    "href": "/procedures/venus-freeze",
    "title": "Venus Freeze",
    "targets": "Wrinkles and loose skin on the face, neck and body",
    "method": "device",
    "description": "Radiofrequency treatment",
    "concerns": [
      "lines",
      "laxity"
    ],
    "aliases": "Venus Freeze Multipolar radiofrequency and magnetic pulses · Venus Concept"
  }
] as const
